import cls from 'classnames';
import React from 'react';
import { default as SvgCheckbox } from '../../assets/Checkbox';
import { default as SvgCheckboxUnchecked } from '../../assets/CheckboxUnchecked';
import { BRAND_COLORS } from '../../config/brand';
import './Checkbox.css';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checkedIcon?: React.ReactNode;
  name?: string;
}
export const Checkbox: React.FC<CheckboxProps> = ({ className, ...props }) => (
  <span
    className={cls(
      className,
      props.checked ? 'lb_checkbox lb_checkbox__checked' : 'lb_checkbox'
    )}
  >
    <input type="checkbox" {...props} />
    {props.checked ? <SvgCheckbox fill={BRAND_COLORS.primary} /> : <SvgCheckboxUnchecked />}
  </span>
);
